import React from "react";

const BreadcrumbBar = ({ children }) => (
  <div className="breadcrumb-bar">
    {children}
  </div>
);

export default BreadcrumbBar;
